module.exports = __webpack_public_path__ + "img/marker_one_yellow2.fd2971cc.png";